"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
const Breadcrumb_styled_1 = require("./Breadcrumb.styled");
const Breadcrumb = ({ items, iconHome }) => ((0, jsx_runtime_1.jsxs)(Breadcrumb_styled_1.Wrapper, { children: [(0, jsx_runtime_1.jsx)(Breadcrumb_styled_1.Home, { children: iconHome || (0, jsx_runtime_1.jsx)(flora_react_icons_1.HouseIcon, {}) }), items.map((item, index) => ((0, jsx_runtime_1.jsxs)(Breadcrumb_styled_1.Item, Object.assign({ size: "bodyMediumStandard" }, { children: [(0, jsx_runtime_1.jsx)(Breadcrumb_styled_1.Divisor, { children: (0, jsx_runtime_1.jsx)(flora_react_icons_1.ChevronRightIcon, {}) }), item] }), `item-breadcrumb-${index}`)))] }));
Breadcrumb.defaultProps = {
    items: [],
};
exports.default = Breadcrumb;
